import { h } from 'preact';
import MaterialComponent from '../Base/MaterialComponent';
export class Formfield extends MaterialComponent {
    constructor() {
        super(...arguments);
        this.componentName = 'form-field';
        this.mdcProps = ['align-end'];
    }
    materialDom(props) {
        return h("div", Object.assign({}, props), this.props.children);
    }
}
export default Formfield;
//# sourceMappingURL=index.js.map